"use strict";
/*
 * Integration App React package
 * {@link https://www.npmjs.com/package/@integration-app/react}
 * v2.13.0
 */
'use client';

import { renderCategories } from '../Dropdown/categoryContentMapping.mjs';
import { getFormulas } from '../../DataBuilder/Formula/index.mjs';
import { SvgIconType } from '../../SvgIcon/svg-icon-type.mjs';
import { filterOptionsByLabel } from './utils.mjs';
import { DropdownCategoryType } from '../types.mjs';
import { ValueType } from '../value-spec.mjs';

class FormulaListOptionsFactory {
  async getOptions({ input, spec }) {
    const formulaTypes = getFormulaTypesForSpec(spec);
    const options = [];
    for (const type of formulaTypes) {
      const formulaSpec = getFormulas()[type];
      options.push({
        label: formulaSpec.name,
        value: {
          [`$${type}`]: null
        },
        childCategory: DropdownCategoryType.FORMULA_CONFIG,
        iconType: SvgIconType.ListOption
      });
    }
    const filteredOptions = filterOptionsByLabel(options, input);
    if (filteredOptions.length > 0) {
      filteredOptions.unshift({
        label: renderCategories[DropdownCategoryType.FORMULA].title,
        isSection: true
      });
    }
    return filteredOptions;
  }
}
function getFormulaTypesForSpec(spec) {
  const result = [];
  const entries = Object.entries(getFormulas());
  for (const [formulaType, formulaSpec] of entries) {
    if (!formulaSpec.appliesToSpec) {
      continue;
    }
    if (!spec?.type || spec.type === ValueType.ANY || formulaSpec.appliesToSpec(spec)) {
      result.push(formulaType);
    }
  }
  return result;
}

export { FormulaListOptionsFactory };
